import React from 'react';
import { animated, useSpring, useTransition } from '@react-spring/web';
import { configuration } from '../../utils/environment';

export function useTestableSpring(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  args: any
) {
  if (configuration.disableAnimations) {
    args = { ...args, immediate: true };
  }
  return useSpring(args);
}

interface TestableSpringProps {
  from: Record<string, unknown>;
  to: Record<string, unknown>;
  children: (style: Record<string, unknown>) => React.ReactNode;
  immediate?: boolean;
}

export const TestableSpring: React.FunctionComponent<TestableSpringProps> = (
  props
) => {
  const immediate = configuration.disableAnimations ? true : props.immediate;
  const style = useSpring({
    from: props.from,
    to: props.to,
    immediate
  });
  return <animated.div style={style}>{props.children(style)}</animated.div>;
};

export function useTestableTransition(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  items: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  config: any
) {
  if (configuration.disableAnimations) {
    config = { ...config, immediate: true };
  }
  return useTransition(items, config);
}
